import { React } from 'react';
import { Link, useNavigate } from "react-router-dom";
import 'react-notifications/lib/notifications.css';

import Header from 'src/layouts/Header';
import Footer from 'src/layouts/Footer';
import ResetPasswordForm from '../components/form/ResetPasswordForm';
import useSEO from 'src/hooks/useSEO';

const ResetPassword = () => {
  useSEO({
    title: 'Reset Password - SphynxPlace.com',
    description: 'Reset your SphynxPlace account password securely.',
    robots: 'noindex, nofollow',
  });
  return (
    <>
      <Header />
      <div className="container mx-auto">
        <ResetPasswordForm />
      </div>
      <Footer />
    </>
  )
}

export default ResetPassword;

